const helpers = {
  formatMoney: (value, options) => {
    const defaults = {
      style: 'currency',
      currency: 'EUR',
      currencySign: 'accounting',
      minimumFractionDigits: 2
    };
    const opt = { ...defaults, ...options };
    return new Intl.NumberFormat('en-US', opt).format(value);
  }
};
export default helpers;
